
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index",
      function () {
        return require("private-next-pages/index/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/index"])
      });
    }
  